import * as React from "react";
import { FormattedMessage } from "react-intl";
import SolidButton from "../solidButton";
import {
  BLUE700,
  GREY900,
  GREY1000,
  WHITE100,
} from "@vingle/wtf-sdk/constants/palette";

interface IUserFollowButton {
  isFollowing: boolean;
  followUser: Vingle.User.IUser;
  onFollow: (user: Vingle.User.IUser) => void;
  onUnFollow: (user: Vingle.User.IUser) => void;
  width?: number;
  height?: number;
  fontSize?: number;
  lineHeight?: number;
}

class UserFollowButton extends React.PureComponent<IUserFollowButton> {
  public render() {
    const {
      isFollowing,
      width = 78,
      height = 30,
      fontSize = 12,
      lineHeight = 2,
    } = this.props;
    if (isFollowing) {
      return (
        <SolidButton
          onClick={this.handleUnfollow}
          buttonText={
            <FormattedMessage id="deck_sidebar.recommend_user_following" />
          }
          wrapperStyle={{
            display: "block",
            textAlign: "center",
            width,
            height,
            maxWidth: "auto",
          }}
          buttonStyle={{
            display: "inline-block",
            verticalAlign: "top",
            border: `solid 1px ${GREY900}`,
            lineHeight,
            color: GREY1000,
            width: "100%",
            height: "100%",
            fontSize: `${fontSize}px`,
          }}
        />
      );
    } else {
      return (
        <SolidButton
          onClick={this.handleFollow}
          buttonText={
            <FormattedMessage id="deck_sidebar.recommend_user_follow" />
          }
          wrapperStyle={{
            display: "block",
            textAlign: "center",
            width,
            height,
            maxWidth: "auto",
          }}
          buttonStyle={{
            display: "inline-block",
            verticalAlign: "top",
            border: `solid 1px ${BLUE700}`,
            backgroundColor: BLUE700,
            lineHeight,
            color: WHITE100,
            width: "100%",
            height: "100%",
            fontSize: `${fontSize}px`,
          }}
        />
      );
    }
  }

  private readonly handleFollow = () => {
    const { onFollow, followUser } = this.props;
    onFollow(followUser);
  };

  private readonly handleUnfollow = () => {
    const { onUnFollow, followUser } = this.props;
    onUnFollow(followUser);
  };
}

export { UserFollowButton as PureUserFollowButton };
export default UserFollowButton;
